/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DateTimeRestrictionValidationData,
    DateTimeRestrictionValidationDataFromJSON,
    DateTimeRestrictionValidationDataFromJSONTyped,
    DateTimeRestrictionValidationDataToJSON,
    ListItemValidationMessage,
    ListItemValidationMessageFromJSON,
    ListItemValidationMessageFromJSONTyped,
    ListItemValidationMessageToJSON,
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface SSRRuleValidationData
 */
export interface SSRRuleValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SSRRuleValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof SSRRuleValidationData
     */
    travelDates?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SSRRuleValidationData
     */
    bookingDateTimeRestrictionsTimeZone?: ValidationMessage;
    /**
     * 
     * @type {Array<DateTimeRestrictionValidationData>}
     * @memberof SSRRuleValidationData
     */
    bookingDateTimeRestrictions?: Array<DateTimeRestrictionValidationData> | null;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SSRRuleValidationData
     */
    description?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SSRRuleValidationData
     */
    ctce?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SSRRuleValidationData
     */
    ctcm?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SSRRuleValidationData
     */
    duplication?: ValidationMessage;
}

export function SSRRuleValidationDataFromJSON(json: any): SSRRuleValidationData {
    return SSRRuleValidationDataFromJSONTyped(json, false);
}

export function SSRRuleValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRRuleValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'bookingDateTimeRestrictionsTimeZone': !exists(json, 'bookingDateTimeRestrictionsTimeZone') ? undefined : ValidationMessageFromJSON(json['bookingDateTimeRestrictionsTimeZone']),
        'bookingDateTimeRestrictions': !exists(json, 'bookingDateTimeRestrictions') ? undefined : (json['bookingDateTimeRestrictions'] === null ? null : (json['bookingDateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionValidationDataFromJSON)),
        'description': !exists(json, 'description') ? undefined : ValidationMessageFromJSON(json['description']),
        'ctce': !exists(json, 'ctce') ? undefined : ValidationMessageFromJSON(json['ctce']),
        'ctcm': !exists(json, 'ctcm') ? undefined : ValidationMessageFromJSON(json['ctcm']),
        'duplication': !exists(json, 'duplication') ? undefined : ValidationMessageFromJSON(json['duplication']),
    };
}

export function SSRRuleValidationDataToJSON(value?: SSRRuleValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'travelDates': value.travelDates === undefined ? undefined : (value.travelDates === null ? null : (value.travelDates as Array<any>).map(ListItemValidationMessageToJSON)),
        'bookingDateTimeRestrictionsTimeZone': ValidationMessageToJSON(value.bookingDateTimeRestrictionsTimeZone),
        'bookingDateTimeRestrictions': value.bookingDateTimeRestrictions === undefined ? undefined : (value.bookingDateTimeRestrictions === null ? null : (value.bookingDateTimeRestrictions as Array<any>).map(DateTimeRestrictionValidationDataToJSON)),
        'description': ValidationMessageToJSON(value.description),
        'ctce': ValidationMessageToJSON(value.ctce),
        'ctcm': ValidationMessageToJSON(value.ctcm),
        'duplication': ValidationMessageToJSON(value.duplication),
    };
}


